import defaultPalette from '../palette';
var getContainedDefault = function (palette) {
    var _a;
    return {
        '&.MuiButtonGroup-groupedContainedHorizontal:not(:first-child)': {
            borderLeft: 'none',
        },
        '&.MuiButtonGroup-groupedContainedHorizontal:not(:last-child)': {
            borderRightColor: (_a = palette === null || palette === void 0 ? void 0 : palette.core) === null || _a === void 0 ? void 0 : _a.main,
        },
        '&.MuiButtonGroup-groupedContainedHorizontal:not(:last-child):disabled': {
            borderRightColor: palette === null || palette === void 0 ? void 0 : palette.core[200],
        },
    };
};
var getContainedVitality = function (palette) {
    var _a;
    return {
        '&.MuiButtonGroup-groupedContainedHorizontal:not(:last-child)': {
            borderRightColor: (_a = palette === null || palette === void 0 ? void 0 : palette.vitality) === null || _a === void 0 ? void 0 : _a.contrastText,
        },
        '&.MuiButtonGroup-groupedContainedHorizontal:not(:last-child):disabled': {
            borderRightColor: palette === null || palette === void 0 ? void 0 : palette.primary[200],
        },
    };
};
export default (function (_a) {
    var _b = _a.palette, palette = _b === void 0 ? defaultPalette : _b;
    return {
        MuiButtonGroup: {
            contained: {
                boxShadow: 'none',
                // Remove border color transition delay so it doesn't show up during focus state
                '& .MuiButtonBase-root': {
                    transition: 'border 0ms',
                    // Increase z-index on Button focus to ensure outline is shown in case hidden under a sibling button
                    '&:focus': {
                        zIndex: 2,
                    },
                    // Hides the right border when focus outline is shown so it looks cleaner
                    '&.MuiButtonGroup-groupedContainedHorizontal:not(:last-child):focus': {
                        borderRightColor: 'transparent',
                    },
                },
                '& .MuiButton-contained': getContainedDefault(palette),
                '& .MuiButton-contained.MuiButton-containedVitality': getContainedVitality(palette),
            },
        },
    };
});
